import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

export const StarFillIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M7.472 8.608 5 7.309 2.528 8.608 3 5.856l-2-1.95 2.764-.401L5 1l1.236 2.505L9 3.906l-2 1.95.472 2.752Z" fill="var(--colors-secondary)" />
            <path d="M6.758 7.61 5 6.685l-1.758.925.336-1.958-1.423-1.386 1.966-.286L5 2.199l.879 1.781 1.966.286-1.423 1.386.336 1.958Z" />
        </SvgIcon>
    );
};
import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

export const StarFillIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M7.472 8.608 5 7.309 2.528 8.608 3 5.856l-2-1.95 2.764-.401L5 1l1.236 2.505L9 3.906l-2 1.95.472 2.752Z" fill="var(--colors-secondary)" />
            <path d="M6.758 7.61 5 6.685l-1.758.925.336-1.958-1.423-1.386 1.966-.286L5 2.199l.879 1.781 1.966.286-1.423 1.386.336 1.958Z" />
        </SvgIcon>
    );
};
